// extracted by mini-css-extract-plugin
export var cartIcon = "_ma-0";
export var cartIconContainer = "_ma-1";